import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import Layout from "@/components/Layout";
import { ArrowRight, MessageCircleHeart, Map, Sparkles } from "lucide-react";

export default function Landing() {
  return (
    <Layout>
      <section className="max-w-3xl mx-auto px-6 py-20 md:py-28 fade-in">
        <p className="text-sm uppercase tracking-widest text-muted-foreground mb-6" data-testid="landing-kicker">
          A quiet space · for difficult conversations
        </p>
        <h1
          className="text-4xl sm:text-5xl lg:text-6xl tracking-tight text-foreground leading-[1.05] mb-8"
          style={{ fontFamily: 'Manrope', fontWeight: 500 }}
          data-testid="landing-heading"
        >
          Conflict Resolution<br />
          <span className="text-primary">Assistant.</span>
        </h1>
        <p className="text-lg text-foreground/70 leading-relaxed max-w-2xl mb-10">
          The Conflict Resolution Assistant is a gentle process that will help you resolve
          conflicts with others in your life. It will coach you on what to say and how to say it.
        </p>
        <div className="flex flex-wrap gap-3">
          <Button asChild className="rounded-full h-12 px-7" data-testid="landing-cta-signup">
            <Link to="/signup">
              Start a session <ArrowRight className="w-4 h-4 ml-2" strokeWidth={1.5} />
            </Link>
          </Button>
          <Button asChild variant="outline" className="rounded-full h-12 px-7" data-testid="landing-cta-login">
            <Link to="/login">I already have an account</Link>
          </Button>
        </div>

        <div className="mt-20 grid md:grid-cols-3 gap-8">
          {[
            { icon: Map, title: "Guided, step-by-step", body: "Six short stages from describing the conflict to preparing what you'll say." },
            { icon: MessageCircleHeart, title: "Supportive, not clinical", body: "A calm coaching voice that listens, suggests, and moves you forward." },
            { icon: Sparkles, title: "Prepared to talk", body: "End with a suggested opening, an invitation, and collaborative options." },
          ].map(({ icon: Icon, title, body }) => (
            <div key={title} className="p-6 rounded-2xl bg-card border border-border/60">
              <Icon className="w-5 h-5 text-primary mb-4" strokeWidth={1.5} />
              <h3 className="text-lg font-medium mb-2" style={{ fontFamily: 'Manrope' }}>{title}</h3>
              <p className="text-sm text-foreground/70 leading-relaxed">{body}</p>
            </div>
          ))}
        </div>
      </section>
    </Layout>
  );
}
